<template>
  <!--激活优惠券弹出框-->
  <div ref="activateContainer" class="activate-container">
    <!--遮罩-->
    <div class="mask" @click="emit_close"></div>
    <div class="activate-wrapper">
      <h3 class="title">
        <span class="title-text">激活优惠券</span>
        <i class="iconfont icon-guanbixiao close" @click="emit_close"></i>
      </h3>
      <div class="input">
        <div class="input-inner">
          <input
            ref="input"
            v-model="couponCode"
            autocomplete=true
            autofocus
            type="text"
            placeholder="请输入优惠码">
          <i v-show="couponCode !== ''" class="iconfont icon-Artboard icon-clear" @click="event_clearCouponCode"></i>
        </div>
      </div>
      <div class="confirm-btn" :disabled="this.couponCode === ''" :class="confirmBtnClassName" @click="event_confirm">确定</div>
    </div>

    <div class="loading" v-show="loading"></div>

    <!--提示框-->
    <div class="toast"><span :class="{'toast-enter-active': showToast}">{{toastDesc}}</span></div>
  </div>
</template>

<script>
  import {activeTicket} from '@/api'
  export default {
    data() {
      return {
        couponCode: '',
        showToast: false,
        toastDesc: '',
        loading: false
      };
    },
    computed: {
      confirmBtnClassName() {
        return this.couponCode === '' ? '' : 'can-click';
      }
    },
    mounted() {
      const _this = this;
      _this.$nextTick(() => {
        _this.$refs.activateContainer.addEventListener('touchmove', (e) => {
          e.preventDefault();
          return false;
        });
        _this.$refs.input.focus();
      });
    },
    methods: {
      emit_close() {
        this.$emit('emit_close');
      },
      event_clearCouponCode() {
        this.couponCode = '';
        this.$refs.input.focus();
      },
      event_confirm() {
        if (this.couponCode === '' || this.loading) {
          return;
        }
        this.loading = true;
        activeTicket(this.couponCode).then(res => {
          this.loading = false;
          const {retCode, retMsg} = res.data;
          // 500-缺少必要参数 404-response error : errMsg 400-null data 11-参数错误 12-用户不存在 13-未成功激活  1-优惠券码无效 2-优惠券已激活 2-其他用户已激活此优惠券 3-此券号不是实体券，无法激活/此券号不是复用券，无法激活 4-优惠券未审核通过 5-优惠券不能使用 6-优惠券未发放 7-优惠券已过期 0-优惠码激活成功
          if (retCode === 0) {
            // this.$router.go(0);
            this._showToastDesc('激活成功');
            this.$emit('emit_refresh');
          } else {
            this._showToastDesc(retMsg);
          }
        }).catch((err) => {
          this.loading = false;
          this._showToastDesc('网络不给力');
        });
      },
      _showToastDesc(msg) {
        const _this = this;
        _this.toastDesc = msg;
        _this.showToast = true;

        setTimeout(() => {
          _this.showToast = false;
        }, 2600);
      }
    }
  }
</script>

<style lang="scss" scoped>
.activate-container {
  position: absolute;
  top: 0;
  height: 100%;
  /*bottom: 0;*/
  width: 100%;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .activate-wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    .title {
      padding: 0 toRem(30);
      height: toRem(110);
      line-height: toRem(110);
      .close {
        font-size: toRem(32);
        float: right;
      }
    }
    .title-text {
      font-size: toRem(34);
      color: #1A191E;
    }
    .input {
      margin-bottom: toRem(30);
      .input-inner {
        position: relative;
        width: toRem(690);
        height: toRem(90);
        margin: 0 auto;
        input {
          width: 100%;
          height: toRem(90);
          padding: toRem(25) 0 toRem(25) toRem(24);
          line-height: toRem(40);
          font-size: toRem(28);
          background-color:  #F5F5F5;
          box-sizing: border-box;
        }
        .icon-clear {
          position: absolute;
          right: toRem(31);
          top: 0;
          height: 100%;
          display: flex;
          align-items: center;
          font-size: toRem(32);
          color: #ccc;
        }
      }
    }
    .confirm-btn {
      width: toRem(690);
      height: toRem(90);
      background-color: #ccc;
      margin: 0 auto toRem(30);
      line-height: toRem(90);
      font-size: toRem(30);
      text-align: center;
      color: #FFF;
      font-family: PingFangSC-Medium;
      &.can-click {
        background-color: #1C1717;
      }
    }
  }
  /*toast提示*/
  .toast {
    pointer-events: none;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 60%;
    z-index: 4000000;
    margin: 0 0.6666667rem;
  }

  .toast span {
    display: inline-block;
    padding: 0.3rem 0.48rem;
    font-size: 0.37333333rem;
    line-height: 0.37333333rem;
    color: #fff;
    background-color: rgba(26, 25, 30, 0.94);
    opacity: 0;

    -webkit-transform: translate3d(0, 120%, 0);
    transform: translate3d(0, 120%, 0);

    -webkit-border-radius: 0.08rem;
    border-radius: 0.08rem;
  }

  @-webkit-keyframes toast {
    11.54% {opacity: 1; -webkit-transform: translate3d(0, 0, 0);}
    87% {opacity: 1; -webkit-transform: translate3d(0, 0, 0);}
    94% {opacity: 0.9; -webkit-transform: translate3d(0, 0, 0) scale(0.9);}
    100% {-webkit-transform: translate3d(0, 70%, 0) scale(0.9);}
  }

  @keyframes toast {
    11.54% {opacity: 1; transform: translate3d(0, 0, 0);}
    87% {opacity: 1; transform: translate3d(0, 0, 0);}
    94% {opacity: 0.9; transform: translate3d(0, 0, 0) scale(0.9);}
    100% {transform: translate3d(0, 70%, 0) scale(0.9);}
  }

  .toast-enter-active {
    -webkit-animation: toast 2.6s;
    animation: toast 2.6s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MActivate/index.vue